export const getCookieValue = (cookieName: string): string | null => {
  if (typeof window === 'undefined') return null;

  const cookie = document.cookie
    .split('; ')
    .find((c) => c.startsWith(`${cookieName}=`))
    ?.split('=')[1];

  return cookie ? decodeURIComponent(cookie) : null;
};
